module.exports = __webpack_public_path__ + "img/20190604161415QQ截图20190603170417.1c031c5e.png";